import styled from 'styled-components';
import {FaTimes} from 'react-icons/fa'
import { Link } from 'react-scroll';


const SideBarContainer = styled.aside`
    position: fixed;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: #0d0d0d;
    display: grid;
    align-items: center;
    top: 0;
    left: 0;
    transition: 0.3s ease-in-out;
    opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
    top: ${({ isOpen }) => ( isOpen ? '0' : '-100%')};
`
const ClostIcon = styled(FaTimes)`
    color: #fff;
`
const Icon = styled.div`
    position: absolute;
    top: 1.2rem;
    right: 1.5rem;
    background: transpartent;
    font-size: 2rem;
    cursor: pointer;
    outline: none;
`
const SideBarWrapper = styled.div`
    color: #fff;

`
const SideBarMenu = styled.ul`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, 80px);
    text-align: center;

    @media screen and (max-width: 768px){
        grid-template-rows: repeat(6, 60px);
    }
`
const SideBarLink = styled(Link)`
    font-family: 'Epilogue', sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    text-decoration: none;
    list-style: none;
    transition: 0.2s ease-in-out;
    text-decoration: none;
    color: #fff;
    cursor: pointer;
    
    &:hover {
        color: #8a65f0;
        transition: 0.2s ease-in-out
    }
`
const SideBarBtnWrap = styled.div`
    display: flex;
    justify-content: center;
`
const SideBarScroll = styled(Link)`
    font-family: 'Epilogue', sans-serif;
    border-radius: 50px;
    background: #8a65f0;
    white-space: nowrap;
    padding: 16px 64px;
    color: #fff;
    font-size: 22px;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;

    &:hover {
        transition: all 0.2s ease-in-out;
        background : #cebfff;
        color: #000;
    }
`



function SideBar({isOpen,toggle}) {

    return(
        <SideBarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <ClostIcon />
            </Icon>
            <SideBarWrapper>
                <SideBarMenu>
                <SideBarLink to='home' onClick={toggle} spy={true} smooth={true} duration={1200} offset={-80}>Home</SideBarLink>
                <SideBarLink to='projects' onClick={toggle} spy={true} smooth={true} duration={1200} offset={-110}>Projects</SideBarLink>   
                <SideBarLink to='about' onClick={toggle} spy={true} smooth={true} duration={1200} offset={-80}>About</SideBarLink>            
                </SideBarMenu>
                <SideBarBtnWrap>
                    <SideBarScroll to='contact' onClick={toggle} spy={true} smooth={true} duration={1200} offset={-80}>Hire me</SideBarScroll>
                </SideBarBtnWrap>
            </SideBarWrapper>
        </SideBarContainer>
    )
}


export default SideBar